import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
const VARIANT_CLASSES = {
    default: 'bg-white/[0.08] border-white/[0.16]',
    strong: 'bg-white/[0.12] border-white/[0.18]',
};
export const GlassPill = forwardRef(({ variant = 'default', className = '', children, ...rest }, ref) => {
    const classes = [
        'inline-flex items-center',
        'py-[7px] px-[14px]',
        'rounded-full border',
        VARIANT_CLASSES[variant],
        'backdrop-blur-[14px]',
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/50 focus-visible:ring-offset-2 focus-visible:ring-offset-transparent',
        className,
    ]
        .filter(Boolean)
        .join(' ');
    return (_jsx("span", { ref: ref, "data-testid": "glass-pill", className: classes, ...rest, children: children }));
});
GlassPill.displayName = 'GlassPill';
